import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=a068d730&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"
import style1 from "./Customers.vue?vue&type=style&index=1&id=a068d730&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a068d730",
  null
  
)

export default component.exports